export var MessagesActions;
(function (MessagesActions) {
    MessagesActions["SEND_EXTENSION_MESSAGE"] = "MESSAGE/SEND_EXTENSION_MESSAGE";
    MessagesActions["REMOVE_EXTENSION_MESSAGE"] = "MESSAGE/REMOVE_EXTENSION_MESSAGE";
})(MessagesActions || (MessagesActions = {}));
export var MessageType;
(function (MessageType) {
    MessageType["ACTION_REQUEST"] = "ACTION_REQUEST";
    MessageType["INSTALL_EXTENSION"] = "INSTALL_EXTENSION";
})(MessageType || (MessageType = {}));
